import { Link } from 'react-router-dom';

import styled from 'styled-components';

import { PAGES } from 'constants/pages';

import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { HotDrinksRecipesList } from './components/HotDrinksRecipesList';

export const HotDrinksRecipes = () => {
    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.hotDrinksRecipes} />
                </HeaderTitle>
                <Link to={PAGES.hotDrinksRecipeCreate.url}>
                    <TotemPrimaryButton>Créer une recette</TotemPrimaryButton>
                </Link>
            </Header>
            <Content>
                <ListContainer>
                    <HotDrinksRecipesList />
                </ListContainer>
            </Content>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    flex: 1;
    overflow: hidden;
`;

const ListContainer = styled.div`
    flex: 1;
    overflow: hidden;
`;
